export enum SnapshotLabels {
  ITS_STATUS_ANNOTATION = `test.appstudio.openshift.io/status`,
  BUILD_PIPELINE_LABEL = `appstudio.openshift.io/build-pipelinerun`,
  PAC_SHA_LABEL = 'pac.test.appstudio.openshift.io/sha',
  PAC_SHA_TITLE_ANNOTATION = 'pac.test.appstudio.openshift.io/sha-title',
  PAC_SHA_URL_ANNOTATION = 'pac.test.appstudio.openshift.io/sha-url',
  PAC_SOURCE_REPO_URL_ANNOTATION = 'pac.test.appstudio.openshift.io/source-repo-url',
  PAC_EVENT_TYPE_LABEL = 'pac.test.appstudio.openshift.io/event-type',
  PAC_PULL_REQUEST_LABEL = 'pac.test.appstudio.openshift.io/pull-request',
  PAC_URL_ORG_LABEL = 'pac.test.appstudio.openshift.io/url-org',
  PAC_URL_REPOSITORY_LABEL = 'pac.test.appstudio.openshift.io/url-repository',
  PAC_GIT_PROVIDER = 'pac.test.appstudio.openshift.io/git-provider',
  PAC_BRANCH = 'pac.test.appstudio.openshift.io/branch',
  PAC_SENDER = 'pac.test.appstudio.openshift.io/sender',
  PAC_REPO_URL = 'pac.test.appstudio.openshift.io/repo-url',
  COMMIT_BRANCH_ANNOTATION = 'build.appstudio.redhat.com/target_branch',
  COMMIT_USER_LABEL = 'pipelinesascode.tekton.dev/sender',
  COMMIT_LABEL = 'pipelinesascode.tekton.dev/sha',
  COMMIT_ANNOTATION = 'build.appstudio.redhat.com/commit_sha',
  APPLICATION = 'appstudio.openshift.io/application',
  COMPONENT = 'appstudio.openshift.io/component',
  BUILD_SERVICE_REPO_ANNOTATION = 'build.appstudio.openshift.io/repo',
  COMMIT_FULL_REPO_URL_ANNOTATION = 'pipelinesascode.tekton.dev/repo-url',
}
